import {BackgroundTask} from './background-task.model';

export interface BackgroundTaskState {
  pendingTasks: BackgroundTask[];
  allTasks: BackgroundTask[];
  completedNotifications: BackgroundTask[];
  isLoading: boolean;
  error: Error | null;
}

export const initialBackgroundTaskState: BackgroundTaskState = {
  pendingTasks: [],
  allTasks: [],
  completedNotifications: [],
  isLoading: false,
  error: null
};
